module.exports = __webpack_public_path__ + "static/product-image-placeholder-3fde6725a311807eec03211e717d8eec.png";